import {MuteState} from '../types';

export const isMediaMuted = (muteState: MuteState) =>
    muteState !== MuteState.Unmuted;
export const isMediaLocked = (muteState: MuteState) =>
    muteState === MuteState.Disabled;
